export const Types = {
  READ: 'aside/READ'
}

const initialState = [
  {
    id: '273',
    title: 'general',
    read: false
  },
  {
    id: '764',
    title: 'random',
    read: false
  },
  {
    id: '636',
    title: 'frontend-team',
    read: false
  },
  {
    id: '403',
    title: 'today-i-learned',
    read: false
  }
]

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Types.READ:
      return state.map(item =>
        item.id === action.payload.id ? { ...item, read: true } : item
      )
    default:
      return state
  }
}

export function setAsRead (id) {
  return {
    type: Types.READ,
    payload: {
      id,
      read: true
    }
  }
}
